export default __webpack_public_path__ + "static/media/1278.ddec76cc.png";